// Modal.js
import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-md flex justify-center items-center z-50">
      <div className="bg-[#1B1B1C] rounded-xl p-0 shadow-lg w-full max-w-[480px] relative border border-[#71777D]">
        <button
          className="absolute top-4 right-5 text-white font-PxBold text-3xl"
          onClick={onClose}
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
